// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  hmr: false,
  //apiUrl: 'https://localhost:7202/api' ,
  //apiUrl: 'https://localhost:5001/api' ,
  // apiUrl: 'https://api-etail.aim-sol.com/api', // old
  //apiUrl: "https://apibeta-v2.etailsupport.com/api", //beta
  apiUrl: 'https://api-v2.etailsupport.com/api', //live
  defaultBrokenUserImage: "../assets/images/logo/logo-icon.png",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
